//url
import { baseUrl, PIN_AD_BASE_URL } from "@/config/config";

export const defaultParams = {
  baseURL: baseUrl,
  credentials: "same-origin",
  timeout: 15000,
  method: "POST"
};

//pinad API:
export const pureSuperPayConfig = "/api/v1/recommend/pure";

// 打点的接口
export const sendEventConfig = "/unify_logs";

//加密API
export const kGetXApiPathSettings = `/OeFS69/L76QjH/VSWL82`;

export const kGetXApiPathUserLogin = (userId: string) =>
  `/ZtPdP5/n6oKLc/4qKGR3/${userId}/qYWn1G`;

export const kGetXApiPathUserInfo = (userId: string | number) =>
  `/bBE5r2/ZMCq4x/evrqQI/${userId}/CxfhS1`;

export const kGetXApiPathGetFeed = (userId: string) =>
  `/RfQonr/V8QwWT/UmWN3m/s1oQRQ/${userId}`;

export const kGetXApiPathFeedAct = (feedId: string | number) =>
  `/jWaOmz/5ZWEzb/BCH488/${feedId}/N5N9iI`;

export const kGetXApiPathUserDisconnect = (userId: string) =>
  `/9A07IG/aTBpxy/PuWlyQ/${userId}/ZaWrUy`;

export const kGetXApiPathRedeem = (userId: string) =>
  `/BcR49X/YxZ0Hd/KIhV19/${userId}/AXV7W9`;

export const kGetXApiPathUserUpgradge = `/chiR5R/V8QwWT/XolrHk/S7LeUw`;

export const kGetXApiPathUserDaily = `/96FEkW/RxectR/XolrHk/%@/9qA9IO`;

export const kGetXApiPathUserDailyConfirm = `/Q0hiVe/malooF/TDrrcy/%@/mdDh8X/dmCJ5z`;

export const kGetXApiPathSpin = `/62bdLH/tMY8Bs/J0w2ML/%@/xyY3GC`;

export const kGetXApiPathSlot = `/JQ9ybX/y5tfAD/T1TAl6/TwQido`;

export const kGetXApiPathMessage = `/8pdnAR/InZL9q/VFIwr9/rSL22G/%@`;

export const kGetXApiPathPopular = `/XAm87G/Ee4Ie6/QvL6xF/6HuGkh`;

export const kGetXApiPathFeedSkip = `/7KHK6q/FeCvp9/NBFz48/%@/heQkP4`;

export const kGetXApiPathFeedBlock = `/chiR5R/resJQs/6sSrFS/UyrhlD`;

export const kGetXApiPathGetTask = `/hLcbe5/RnGp2d/eh49DD/DN6iht/%@`;

export const kGetXApiPathOffer = (offerId: string | number) =>
  `/hBuUf3/lLxskJ/TycWSx/${offerId}`;

export const kGetXApiPathActTask = (masterId: string | number) =>
  `/jdO5Pk/qJyTK4/eG3bhj/${masterId}/qmHwJq`;

export const kGetXApiPathIapHistory = (userId: string) =>
  `/nZw4BR/Gtu8HW/Q5ltTM/gDxxJs/${userId}`;

export const kGetXApiPathSetPaymentSwitcher = (masterId: string | number) =>
  `/bBE5r2/ZMCq4x/evrqQI/${masterId}/CxfhS1`;

export const kGetXApiPathRecommendation = `/iYeVZ0/DYB7xy/ui1MmD`;

export const kGetXApiPathContent = `/4o9XEC/YVkJs0/LmDvd6/Yth2FZ`;

export const kGetXApiPathUserTaskResult = `/H0skkL/UBlW5x/sFNS6w/Iglihq/kvvJFq`;

export const kGetXApiPathGetInformation = `/fqjMQy/YL64aL/r5dzDD/jevXXc`;

export const kGetXApiPathUserAct = `/fpkMPz/YK74bK/r6czEC/jfuXYb/keuXYb`;

export const kGetXApiPathGetTreeToken = `/IU9pC2/oH40PQ/umpXaM/NqIC89`;

export const kGetXApiPathPostFreeFollow = `/DXSoy0/W9HmXj/Z3YtZM/A092SB/eObFx9`;

export const kGetXApiPathAddMePopularUser = `/iZTh6R/iUO9Hy/D5DY1u`;
export const kGetXApiPathAddMeViewedList = `/iZTh6R/iUO9Hy/JQ9ybX`;
export const kGetXApiPathAddMeLikedList = `/iZTh6R/iUO9Hy/y5tfAD`;
export const kGetXApiPathAddMeSearchHot = `/iZTh6R/iUO9Hy/qrfoNR`;

export const kGetXApiActFreeFollow = `/DXSoy0/W9HmXj/Z3YtZM/A092SB/eObFx9`;
export const kGetXApiCasino = `/JQ9ybX/UBlW5x/XolrHk/bYO97B`;

export const kGetXApiPathBindUser = `/7KHK6q/zck6JE/Q5ltTM/ZWkk3M/OIgg0w`;
export const kGetXApiPathServiceList = `/7KHK6q/DcIrv5/ZWkk3M/b8osLE`;

export const kGetXApiPathCheckIn = (masterId: string | number) =>
  `/Q0hiVe/malooF/TDrrcy/${masterId}/mdDh8X/dmCJ5z`;

export const kGetXApiGetRecommendation = `/iYeVZ0/DYB7xy/ui1MmD`;

// api/v5/freefollow/check
export const kGetXApiGetCheckFreeFollowers = `/XAm87G/DcIrv5/X101CD/BetlP6`;
// api/v5/freefollow/deliver
export const kGetXApiGetDeliverFreeFollowers = `/XAm87G/DcIrv5/X101CD/mYFG36`;

export const kGetXApiTransferMasterAccount = `/OeFS69/2WCTe7/evrqQI/WgKohx`;

export const kGetXApiPostOfferV3 = `/RfQonr/2WCTe7/umpXaM/4zUQiJ`;

export const kGetXApiAdvertisementAct = "/XAm87G/DcIrv5/8Ebb4M/qmHwJq";
export const kGetXApiAdvertisementList = "/XAm87G/DcIrv5/8Ebb4M/b8osLE";
